import { useMutation } from "react-query";
import vesselService from "../services/vesselService";

const useGetVessel = (onData) => {
  return useMutation(vesselService.getVessel, {
    onSuccess: (data) => onData(data),
  });
};

const useCreateVessel = (onData) => {
  return useMutation(vesselService.createVessel, {
    onSuccess: (data) => onData(data),
  });
};

const useUpdateVessel = (onData) => {
  return useMutation(vesselService.updateVessel, {
    onSuccess: (data) => onData(data),
  });
};

const useDeleteVessel = (onData) => {
  return useMutation(vesselService.deleteVessel, {
    onSuccess: (data) => onData(data),
  });
};

const vesselQueries = {
  useGetVessel,
  useCreateVessel,
  useUpdateVessel,
  useDeleteVessel
};

export default vesselQueries;
